import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "store/auth/selectors";

export default () => {
  const { userGuiding } = window;
  const user = useSelector(selectUser);
  useEffect(() => {
    const { role, email, id } = user;
    const shouldIdentify = role !== "exhibitor" && userGuiding && id;
    if (shouldIdentify) {
      userGuiding.identify(id, { role, email });
    }
  }, [user, userGuiding]);
};
